import type { WebsiteBlock, WebsiteMediaView } from "@shared/websiteContent";

export function WebsiteBlocks({ blocks, media = [] }: {
  blocks: WebsiteBlock[];
  media?: WebsiteMediaView[];
}) {
  const byId = new Map(media.map(item => [item.id, item]));
  return <div className="website-blocks">{blocks.map(block => {
    const asset = block.mediaId ? byId.get(block.mediaId) : undefined;
    if (block.type === "heading") return <h2 id={block.id} style={{ scrollMarginTop: 110 }} key={block.id}>{block.text}</h2>;
    if (block.type === "text") {
      const lines = block.text.split("\n");
      if (lines.length > 1 && lines.every(line => line.startsWith("- "))) return <ul key={block.id}>{lines.map((line, index) => <li key={index}>{line.slice(2)}</li>)}</ul>;
      return <p style={{ whiteSpace: "pre-line" }} key={block.id}>{block.text}</p>;
    }
    if (block.type === "button") return block.href
      ? <a className="website-content-cta" key={block.id} href={block.href}>{block.text || "Learn more"}</a>
      : <p key={block.id}>{block.text}</p>;
    if (block.type === "image" && asset) return <figure key={block.id}><img src={asset.url} alt={asset.alt || ""} /><figcaption>{asset.caption || block.text}</figcaption></figure>;
    if (block.type === "video" && asset) return <figure key={block.id}><video src={asset.url} controls preload="metadata" /><figcaption>{asset.caption || block.text}</figcaption></figure>;
    if (block.type === "document" && asset) return <p key={block.id}><a href={asset.url} target="_blank" rel="noreferrer">{block.text || asset.title}</a></p>;
    return block.text ? <p key={block.id}>{block.text}</p> : null;
  })}</div>;
}
